import { jsx as _jsx } from "react/jsx-runtime";
import { FlowNode, flowNodeColor, NodeTypeComponent } from 'fable/flowEditor';
import { AutomationNodeTypes } from 'hocs';
import { noModal } from '../modals';
export class CloseNode extends NodeTypeComponent() {
    render() {
        return (_jsx(FlowNode, { color: CloseNode.color, icon: CloseNode.icon, label: CloseNode.label }));
    }
}
CloseNode.icon = 'close-circle-filled';
CloseNode.label = 'Close conversation';
CloseNode.color = flowNodeColor.red;
CloseNode.helpText = 'Close the conversation entirely when it matches predetermined criteria (e.g. after a filter or tag is applied, after an auto-reply is sent, etc.). Note that once the conversation is closed, it will not be sent to a queue or agent.';
CloseNode.ActionModal = noModal(AutomationNodeTypes.CLOSE);
CloseNode.actionTrigger = { type: AutomationNodeTypes.CLOSE };
CloseNode.updateConnection = (node) => {
    return node;
};
